import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { create } from "@/lib/store";
import { hashStorage } from "@/shared/utils/hashStorage";

import { DateGranularity } from "../api/useBrandEquity";

const STORE_NAME = "Brand Equity";
interface BrandEquityState {
  filters: {
    targetNodeUUID: string | null;
  };
  chart: {
    dateGranularity: DateGranularity;
    isDollarData: boolean;
  };
}

interface BrandEquityActions {
  setTargetNode: (node: string | null) => void;
  setDateGranularity: (dateGranularity: DateGranularity) => void;
  setIsDollarData: (isDollarViewSelected: boolean) => void;
}

type StoreState = BrandEquityState & BrandEquityActions;

const defaultState: BrandEquityState = {
  filters: {
    targetNodeUUID: null,
  },
  chart: {
    dateGranularity: "month",
    isDollarData: true,
  },
};

export const useBrandEquityStore = create<StoreState>()(
  devtools(
    persist(
      immer((set) => ({
        ...defaultState,
        setTargetNode: (node) =>
          set((state) => {
            state.filters.targetNodeUUID = node;
          }),
        setDateGranularity: (dateGranularity) =>
          set((state) => {
            state.chart.dateGranularity = dateGranularity;
          }),
        setIsDollarData: (isDollarData) =>
          set((state) => {
            state.chart.isDollarData = isDollarData;
          }),
      })),
      {
        name: STORE_NAME,
        storage: createJSONStorage(() => hashStorage),
      }
    ),
    { name: STORE_NAME }
  )
);
